import { render, staticRenderFns } from "./VRamCalculator.vue?vue&type=template&id=14ed54a9&scoped=true"
import script from "./VRamCalculator.vue?vue&type=script&lang=ts"
export * from "./VRamCalculator.vue?vue&type=script&lang=ts"
import style0 from "./VRamCalculator.vue?vue&type=style&index=0&id=14ed54a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed54a9",
  null
  
)

export default component.exports